<template>
  <div>
    <head-nav-bar :title="title" :fixed="true" />
    <div class="mt-header-nav room-form" ref="RoomBox">
      <van-cell-group>
        <van-cell class="custom-filed">
          <van-row>
            <van-col span="12">
              <van-field
                class="my-name"
                v-model="form.contact"
                required
                clearable
                label="姓名"
                placeholder="请输入姓名"
                @input="changeName"
                @focus="focusName"
                @blur="show = false"
              />
            </van-col>
            <van-col span="12">
              <van-field
                class="phone"
                v-model="form.phone"
                type="tel"
                clearable
                label="电话"
                placeholder="请输入电话"
              />
            </van-col>
          </van-row>
        </van-cell>
        <form-select
          label="渠道"
          :required="defaultItem.MustFillChannel == '1'"
          v-model="form.chanel"
          :columns="ChannelData"
          @change="handleChanel"
        ></form-select>
        <van-field
          label="渠道单号"
          placeholder="请输入渠道单号"
          v-model="form.channelOrderNo"
        />
        <form-select
          label="业务员"
          v-model="form.salesmanId"
          :columns="salesmanData"
        ></form-select>
        <van-field
          label="客户"
          placeholder="请选择客户"
          @click="handleCustomer"
          v-model="form.customerName"
          right-icon="arrow"
          readonly
        />
        <van-field
          label="会员卡"
          placeholder="请选择会员卡"
          @click="handleMember"
          v-model="form.member.Name"
          right-icon="arrow"
          readonly
        />
        <form-select
          label="价类"
          :required="true"
          v-model="form.priceCode"
          :columns="pricecodeData"
          @change="data => handlePriceCode(data.Id)"
        ></form-select>
        <form-select
          label="付款方式"
          v-model="form.payway"
          :columns="paywayData"
          textKey="Name"
          :readonly="isUpdate"
        ></form-select>
        <van-cell :class="{ 'custom-filed': true, 'readonly-cls': isUpdate }">
          <van-row>
            <van-col span="12">
              <van-field
                :readonly="isUpdate"
                :disabled="isUpdate"
                class="money"
                type="number"
                v-model="form.money"
                label="金额"
                placeholder="请输入金额"
              />
              <!-- <van-number-keyboard
                :show="visible.showKeyboard"
                v-model="form.money"
                extra-key="."
                close-button-text="完成"
                @blur="visible.showKeyboard = false"
              /> -->
            </van-col>
            <van-col span="12">
              <van-field
                v-model="form.billNo"
                clearable
                label="单据号"
                :readonly="isUpdate"
                :disabled="isUpdate"
                placeholder="请输入单据号"
              />
            </van-col>
          </van-row>
        </van-cell>
        <van-field
          label="备注信息"
          placeholder="请输入备注信息"
          v-model="form.remark"
          rows="2"
          autosize
          type="textarea"
        />
      </van-cell-group>

      <van-row>
        <van-col span="24">
          <roomInfo
            ref="roomInfo"
            :option="roomInfoOption"
            :defaultItem="defaultItem"
            :isHourRoom="IsHourRoom"
            :hourNumber="HourNumber"
            :pricecodeData="pricecodeData"
            :pricecodeId="form.priceCode"
            :orderAttr="roomInfo.OrderAttr"
            @update="updateName"
            @change="changeDailyPrice"
            @calculate="calculateRoomPrice"
          ></roomInfo>
        </van-col>
      </van-row>
      <van-goods-action>
        <div class="total" slot="default">
          <small>合计：</small>{{ totalMoney }}
        </div>
        <van-goods-action-button
          type="info"
          v-if="roomInfo.actionType == 'order'"
          text="预定"
          @click="onSubmit"
        />
        <van-goods-action-button
          type="info"
          v-if="roomInfo.actionType == 'checkin'"
          text="开房"
          @click="onSubmit"
        />
        <van-goods-action-button
          type="info"
          v-if="isUpdate"
          text="修改订单"
          @click="onSubmit"
        />
      </van-goods-action>
    </div>
    <van-popup
      v-model="visible.showResult"
      close-icon-position="top-left"
      position="top"
      closeable
      @close="onClose"
      :style="{ height: '100%' }"
    >
      <result state="success">
        <div slot="title">{{ title }}成功</div>
        <div slot="desc">
          <div style="width:50%;margin:0 auto">
            {{ desc }}
          </div>
          <div class="to-detail" v-if="!fail">
            <van-cell title="查看订单" is-link value="详情" :to="toDetail" />
          </div>
        </div>
      </result>
    </van-popup>
    <!-- <van-dialog
      v-model="visible.showMemberPass"
      title="请输入会员卡密码"
      @confirm="onSubmitMemberPass"
      show-cancel-button
    >
      <van-field
        style="margin-top:20px"
        placeholder="请输入会员卡密码"
        v-model="form.memberPass"
      />
    </van-dialog> -->
    <van-popup
      class="name-pop"
      v-model="show"
      :style="{ height: '30%' }"
      :overlay="false"
    >
      <ul>
        <li
          v-for="(item, index) in nameDataSource"
          @click="selectName(item)"
          :key="index"
        >
          {{ item.Contact }}
          <span style="float:right">{{ item.Phone }}</span>
        </li>
      </ul>
    </van-popup>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Row,
  Col,
  Field,
  Toast,
  NumberKeyboard,
  Button,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Popup,
  Icon,
  Dialog,
  Notify,
} from "vant";
import { ls } from "@/utils/cache.js";
import { getSelectData, GetDefaultItem } from "@/api/common.js";
import { getUserList } from "@/api/user.js";
import { mapState } from "vuex";
import roomApi from "../../api/room.js";
import orderApi from "../../api/order.js";
import roomInfo from "./roomComponent/RoomInfo.vue";
import formSelect from "@/components/form-select";
import cloneDeep from "lodash/cloneDeep";
import Result from "@/components/result";
import selectMember from "@/components/select-member/function.js";
import MemberPasswordVerify from "@/components/member-password-verify/function.js";
import { ROOMINFO } from "@/store/mutation-types";
import { checkPhone } from "@/utils/common.js";
import moment from "moment";
export default {
  name: "roomLog",
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [NumberKeyboard.name]: NumberKeyboard,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    roomInfo,
    formSelect,
    Result,
  },
  data() {
    return {
      title: "开房",
      submitMethod: "",
      form: {
        contact: "",
        phone: "",
        chanel: "",
        salesmanId: "",
        customerId: "",
        customerName: "",
        member: {},
        memberPass: "",
        priceCode: "",
        payway: "",
        money: "",
        billNo: "",
        remark: "",
      },
      currentCustomer: {},
      params: {},
      visible: {
        showKeyboard: false,
        showResult: false,
        // showMemberPass: false
      },
      defaultItem: {},
      priceStructureData: [],
      pickerData: [],
      ChannelData: [],
      salesmanData: [],
      customerData: [],
      memberData: [],
      pricecodeData: [],
      paywayData: [],
      roomInfoOption: {},
      roomGridData: [],
      desc: "",
      toDetail: "",
      orderId: "",
      orderNo: "",
      fail: false,
      totalMoney: 0,
      isUpdate: false,
      isAllCancel: false,
      IsHourRoom: false,
      HourNumber: "",
      show: false,
      nameDataSource: [],
    };
  },
  watch: {
    roomInfoOption: {
      handler: function() {
        this.calculateTotalPrice();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
      // roomInfo: state => state.room.info
    }),
  },
  created() {
    this.roomInfo = ls.get(ROOMINFO);
    this.getDefaultItem();
    this.getFormSelectData();
    this.roomInfoOption = cloneDeep(this.roomInfo);
    const type = this.roomInfoOption.actionType;
    if (type == "checkin") {
      this.submitMethod = "openRoom";
      this.title = "开房";
    } else if (type == "order") {
      this.submitMethod = "createOrder";
      this.title = "预定";
    } else if (type == "update") {
      this.submitMethod = "updateOrder";
      this.title = "修改订单";
      this.isUpdate = true;
      this.orderId = this.$route.query.id;
      this.handleUpdateData();
    }
  },
  methods: {
    changeName(value) {
      this.nameDataSource = [];
      if (value && value.length > 1) {
        roomApi
          .GetContact({
            Contact: value && value.trim(),
            PageIndex: 0,
            PageSize: 10000,
          })
          .then(res => {
            this.nameDataSource = res.Data.Datas;
            if (res.Data.Datas.length) {
              this.show = true;
            } else {
              this.show = false;
            }
          })
          .catch(() => {
            this.show = false;
          });
      } else {
        this.show = false;
      }
    },
    selectName(item) {
      this.show = false;
      this.form.contact = item.Contact;
      this.form.phone = item.Phone;
    },
    focusName() {
      if (this.form.contact.length > 1) {
        this.changeName(this.form.contact);
      }
    },
    onSubmit() {
      if (!this.validate()) {
        return;
      }
      const form = this.form;
      const formData = {
        Contact: this.convertValue(form.contact),
        Phone: this.convertValue(form.phone),
        ContactRemark: this.convertValue(form.remark),
        AccountItemId: this.convertValue(form.payway),
        BillNo: this.convertValue(form.billNo),
        Deposit: this.convertValue(form.money),
        ChannelId: this.convertValue(form.chanel),
        SalesmanId: this.convertValue(form.salesmanId),
        CustomerId: this.convertValue(form.customerId),
        MemberCardNo: this.convertValue(form.member.CardNo),
        MemberCardId: this.convertValue(form.member.Id),
        MemberName: this.convertValue(form.member.Name),
        PriceCodeId: this.convertValue(form.priceCode),
        IsHourRoom: this.IsHourRoom,
        ChannelOrderNo: form.channelOrderNo,
      };
      const details = this.roomInfoOption.gridData.map(v => {
        // let inTime = v.inTime ? v.inTime : this.defaultItem.ArrivalsTime;
        // let outTime = v.outTime ? v.outTime : this.defaultItem.DepartureTime;
        // let startTime = v.daterange[0] + " " + inTime;
        // let startTime = v.daterange[0] + " " + this.defaultItem.ArrivalsTime;
        let startTime = "";
        let endTime = v.daterange[1] + " " + this.defaultItem.DepartureTime;
        if (
          this.form.member &&
          this.form.member.Id &&
          this.form.member.Id != 0
        ) {
          const time = this.form.member.CheckoutTime
            ? this.form.member.CheckoutTime
            : this.defaultItem.DepartureTime;
          endTime = v.daterange[1] + " " + time;
        }
        //预订单和新订单预抵时间取日期加默认预抵时间，其他的状态取返回日期和时间
        if (!v.OrderStatus || v.OrderStatus == 0) {
          startTime = v.daterange[0] + " " + this.defaultItem.ArrivalsTime;
        } else {
          startTime = v.daterange[0] + " " + v.inTime;
        }
        const now = moment(this.user.AccountDate).format("YYYY-MM-DD");
        const isBeforeToday = moment(v.daterange[0], "YYYY-MM-DD").isBefore(
          now,
        );
        if (this.IsHourRoom) {
          startTime = v.daterange[0];
          endTime = v.daterange[1];
          const isAdditionalOder =
            moment(endTime).isBefore(this.user.AccountDate) &&
            (v.OrderStatus == 0 || v.OrderStatus == 1);
          if (!isAdditionalOder) {
            if (this.roomInfoOption.actionType == "update" && !v.isNew) {
              startTime =
                moment(v.baseDaterange[0]).format("YYYY-MM-DD") +
                " " +
                v.inTime;
            } else if (now != moment().format("YYYY-MM-DD") && !isBeforeToday) {
              startTime = now + " " + this.defaultItem.ArrivalsTime;
              // v.TransactionPrices.forEach(el => {
              //   el.Date = now;
              //   el.PriceDate = now;
              // });
            }
          }
          if (this.roomGridData.actionType == "order" || v.OrderStatus == 0) {
            startTime =
              moment(v.daterange[0]).format("YYYY-MM-DD") +
              " " +
              this.defaultItem.ArrivalsTime;
            endTime =
              moment(v.daterange[1]).format("YYYY-MM-DD") +
              " " +
              this.defaultItem.DepartureTime;
            if (
              this.form.member &&
              this.form.member.Id > 0 &&
              this.form.member.CheckoutTime
            ) {
              endTime =
                moment(v.daterange[1]).format("YYYY-MM-DD") +
                " " +
                this.form.member.CheckoutTime;
            }
            if (moment(startTime).valueOf() > moment(endTime).valueOf()) {
              endTime = moment(v.daterange[1]).format("YYYY-MM-DD") + " 23:00";
            }
          }
        }
        const info = {
          Id: v.Id,
          OrderId: v.isNew ? 0 : this.orderId,
          OrderStatus: v.OrderStatus,
          StatusName: v.StatusName,
          CheckInTime: startTime,
          CheckOutTime: endTime,
          RoomTypeId: v.roomTypeId,
          RoomTypeName: v.roomTypeName,
          RoomId: this.convertValue(v.roomId),
          RoomNo: this.convertValue(v.roomNo),
          PriceStructureId: this.convertValue(v.priceStructure),
          TransactionPrices: cloneDeep(v.TransactionPrices),
          Persons: v.Persons.map(el => {
            delete el.isNew;
            return el;
          }),
        };
        info.RoomPrice = info.TransactionPrices[0].Price;
        info.TransactionPrices.forEach(el => {
          el.RoomNo = info.RoomNo;
        });
        return info;
      });
      this.params = {
        ...formData,
        Details: details,
      };
      const payId = this.isMemberPayMethod();
      if (payId && form.payway == payId && !this.form.member.CardNo) {
        Notify("付款方式为会员卡消费，请选择会员卡！");
        return;
      }
      if (payId && form.member.CardNo && form.payway == payId) {
        if (
          this.isUpdate &&
          this.form.member.Id == this.roomInfo.MemberCardId
        ) {
          //
        } else {
          if (Number(this.form.member.Balance) < Number(this.form.money)) {
            Notify("会员卡余额不足！");
            return;
          }
          MemberPasswordVerify({
            showMoney: !this.isUpdate,
            title: "请输入会员卡密码",
            MemberCardId: form.member.Id,
            money: form.money ? form.money : 0,
            success: password => {
              console.log("success", password);
              this.handleSubmit();
            },
            error: () => {
              console.log("error");
            },
          });
          return;
        }
      }
      this.handleSubmit();
    },
    handleSubmit() {
      if (this.isUpdate) {
        this.params = {
          ...this.params,
          Id: this.orderId,
          OrderNo: this.orderNo,
        };
      }
      if (this.isAllCancel) {
        this.toDetail = "../order/detail?id=" + this.orderId;
        this.visible.showResult = true;
      } else {
        orderApi[this.submitMethod](this.params).then(res => {
          this.fail = false;
          this.desc = "已" + this.title + "成功，请及时联系客人确认入住信息";
          if (this.roomInfoOption.actionType != "update") {
            this.orderId = res.Data;
          }
          this.toDetail = "../order/detail?id=" + this.orderId;
          this.visible.showResult = true;
        });
      }
    },
    validate() {
      if (!this.form.contact) {
        Notify("姓名不能为空！");
        return false;
      }
      const validPhone = checkPhone(this.form.phone);
      if (this.form.phone && !validPhone) {
        Notify("手机号码格式不对！");
        return false;
      }
      if (Number(this.form.money) > 0 && !this.form.payway) {
        Notify("金额大于0，请选择付款方式");
        return false;
      }
      if (!this.form.priceCode || this.form.priceCode == 0) {
        Notify("请选择价类！");
        return false;
      }
      if (
        this.defaultItem.MustFillChannel == "1" &&
        (!this.form.chanel || this.form.chanel == 0)
      ) {
        Notify("请选择渠道！");
        return false;
      }
      if (!this.roomInfoOption.gridData.length) {
        Notify("请添加房间信息！");
        return false;
      }
      const formIsValid = this.roomInfoOption.gridData.every(
        field => field.roomTypeId !== "",
      );
      if (!formIsValid) {
        Notify("请选择房型！");
        return false;
      }
      const dateValid = this.roomInfoOption.gridData.every(
        field =>
          field.daterange &&
          field.daterange[0] !== "" &&
          field.daterange[1] !== "",
      );
      if (!dateValid) {
        Notify("请选择日期！");
        return false;
      }
      return true;
    },
    convertValue(val) {
      return !val || val.trim() == "" || val.trim() == "0"
        ? undefined
        : val.trim();
    },
    /**处理修改订单数据 */
    handleUpdateData() {
      // const
      const updateData = cloneDeep(this.roomInfo);
      this.orderNo = updateData.OrderNo;
      this.IsHourRoom = updateData.IsHourRoom;
      this.form = {
        contact: updateData.Contact,
        phone: updateData.Phone,
        chanel: updateData.ChannelId,
        salesmanId: updateData.SalesmanId,
        customerId: updateData.CustomerId,
        customerName: updateData.CustomerName,
        member: {
          Name: updateData.MemberName,
          CardNo: updateData.MemberCardNo,
          Id: updateData.MemberCardId,
        },
        priceCode: updateData.PriceCodeId,
        payway: updateData.AccountItemId,
        money: String(updateData.Deposit),
        billNo: updateData.BillNo,
        remark: updateData.ContactRemark,
        channelOrderNo: updateData.ChannelOrderNo,
      };
      const gridData = [];
      updateData.Details.forEach(v => {
        const params = {
          CheckInTime: v.CheckInTime,
          CheckOutTime: v.CheckOutTime,
          RoomTypeId: v.RoomTypeId,
          OrderId: this.orderId,
        };
        roomApi.GetRoomAvailable(params).then(res => {
          let start = moment(v.CheckInTime).format("YYYY-MM-DD");
          let end = moment(v.CheckOutTime).format("YYYY-MM-DD");
          if (this.IsHourRoom) {
            start = moment(v.CheckInTime).format("YYYY-MM-DD HH:mm");

            const isAdditionalOder =
              moment(end).isBefore(this.user.AccountDate) &&
              (v.OrderStatus == 0 || v.OrderStatus == 1);
            if (!isAdditionalOder) {
              start = moment(v.OperationInTime).format("YYYY-MM-DD HH:mm");
            }
            end = moment(v.CheckOutTime).format("YYYY-MM-DD HH:mm");
            if (v.OrderStatus == 0) {
              start = moment(v.CheckInTime).format("YYYY-MM-DD");
              end = moment(v.CheckOutTime).format("YYYY-MM-DD");
            }
          }
          const json = {
            Id: v.Id,
            OrderId: this.orderId,
            daterange: [start, end],
            days: moment(v.CheckOutDate).diff(moment(v.CheckInDate), "d"),
            inTime: moment(v.CheckInTime).format("HH:mm"),
            outTime: moment(v.CheckOutTime).format("HH:mm"),
            price:
              this.defaultItem.RoomPriceInputModel == "1"
                ? v.TotalRoomPrice
                : v.DailyPrices[0].Price,
            roomTypeId: v.RoomTypeId,
            roomTypeName: v.RoomTypeName,
            roomId: v.RoomId,
            roomNo: v.RoomNo,
            roomNoList: res.Data.RoomNos,
            Persons: v.Persons,
            priceStructure: v.PriceStructureId,
            OrderStatus: v.OrderStatus,
            StatusName: v.StatusName,
            disabled: {
              disabledStart:
                v.OrderStatus == 2 ||
                v.OrderStatus == 4 ||
                v.OrderStatus == 1 ||
                (this.IsHourRoom && v.OrderStatus != 0),
              disabledEnd: v.OrderStatus == 2 || this.IsHourRoom,
            },
          };
          json.baseDaterange = [v.CheckInTime, v.CheckOutTime];
          if (v.OrderStatus == 4 || v.OrderStatus == 2 || v.OrderStatus == 3) {
            //完成或者取消或者暂离
            json.isDisabled = true;
          }
          json.disabledRoom =
            moment(v.CheckOutTime).isBefore(this.user.AccountDate) &&
            this.IsHourRoom;
          if (v.OrderStatus == 1) {
            //在住
            json.isInRoom = true;
          }
          json.TransactionPrices = v.DailyPrices.map(el => {
            return {
              Id: el.Id,
              Date: el.PriceDate,
              PriceDate: el.PriceDate,
              Price: el.Price,
              RoomNo: v.RoomNo,
            };
          });
          json.BaseTransactionPrices = cloneDeep(json.TransactionPrices);
          json.DailyPrices = cloneDeep(json.TransactionPrices);
          gridData.push(json);
        });
      });
      const data = {
        gridData: gridData,
        orderId: this.orderId,
        actionType: updateData.actionType,
        jumpToName: updateData.jumpToName,
        Status: updateData.Status,
      };
      this.roomInfoOption = data;
    },
    onClose() {
      if (this.isUpdate) {
        this.$router.push({
          name: this.roomInfoOption.jumpToName,
          query: { id: this.orderId },
        });
      } else {
        this.$router.push({ name: this.roomInfoOption.jumpToName });
      }
    },
    //获取系统参数值
    getDefaultItem() {
      GetDefaultItem({}).then(res => {
        this.defaultItem = {
          PriceCodeId: res.Data.PriceCodeId,
          isShowTime: res.Data.RoomStatusModel == "0",
          IsIndependentPriceCode: res.Data.IsIndependentPriceCode,
          IsHoldTotalPrice: res.Data.IsHoldTotalPrice,
        };
        res.Data.DoorlockConfigList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
        res.Data.SystemConstList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
        res.Data.TimeList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
        if (!this.form.priceCode || this.form.priceCode == 0) {
          this.handlePriceCode(res.Data.PriceCodeId);
        }
      });
    },
    /**选择价类*/
    handlePriceCode(Id) {
      this.form.priceCode = Id;
      const result = this.pricecodeData.find(
        item => item.Id == Id && item.BackUpBool,
      );
      this.IsHourRoom = result != undefined;
      this.HourNumber = result != undefined ? Number(result.BackUpInt) : 0;
      if (this.roomInfoOption.gridData && this.roomInfoOption.gridData.length) {
        this.roomInfoOption.gridData.forEach((item, index) => {
          if (this.IsHourRoom) {
            if (
              this.roomInfoOption.actionType == "order" ||
              item.OrderStatus == 0
            ) {
              item.daterange = [
                moment(item.baseDaterange[0]).format("YYYY-MM-DD"),
                moment(item.baseDaterange[0])
                  .add(1, "d")
                  .format("YYYY-MM-DD"),
              ];
              item.disabled = {
                disabledStart: false,
                disabledEnd: false,
              };
            } else {
              const now = moment(this.user.AccountDate).format("YYYY-MM-DD");
              let date = moment(item.daterange[0]).format("YYYY-MM-DD");
              if (
                item.OrderStatus != 4 &&
                item.OrderStatus != 2 &&
                item.OrderStatus != 3
              ) {
                let time = item.inTime;
                if (this.roomInfoOption.actionType !== "update") {
                  const isBeforeToday = moment(
                    item.daterange[0],
                    "YYYY-MM-DD",
                  ).isBefore(now);
                  if (isBeforeToday) {
                    //补录订单钟点房，时间取补录日期加默认预抵时间
                    time = this.defaultItem.ArrivalsTime;
                  } else {
                    //订单钟点房，显示自然日期，但是传值的时候CheckInTime传账务日期加预抵时间， CheckOutTime传自然日期的加钟点房小时的时间
                    date = moment().format("YYYY-MM-DD");
                    time = moment().format("HH:mm");
                  }
                }
                const endDate = moment(date + " " + time).add(
                  this.HourNumber,
                  "h",
                );
                const endStr = moment(endDate).format("YYYY-MM-DD HH:mm");
                item.daterange = [date + " " + time, endStr];
                item.disabled = {
                  disabledStart: true,
                  disabledEnd: true,
                };
              }
            }
          } else {
            item.daterange = [
              moment(item.baseDaterange[0]).format("YYYY-MM-DD"),
              moment(item.baseDaterange[1]).format("YYYY-MM-DD"),
            ];
            item.disabled =
              this.roomInfoOption.actionType == "update"
                ? {
                    disabledStart:
                      item.OrderStatus == 2 ||
                      item.OrderStatus == 3 ||
                      item.OrderStatus == 4 ||
                      item.OrderStatus == 1,
                    disabledEnd: item.OrderStatus == 2,
                  }
                : {
                    disabledStart: this.roomInfoOption.actionType == "checkin",
                    disabledEnd: false,
                  };
          }
          if (item.OrderStatus != 2) {
            this.changeDailyPrice(item, index);
          }
        });
      }
    },
    /**选择渠道*/
    handleChanel(data) {
      if (
        !this.defaultItem.IsIndependentPriceCode &&
        !Number(this.form.customerId) &&
        data.Data
      ) {
        this.handlePriceCode(data.Data.PriceCodeId);
      }
    },
    clearPriceCode() {
      const result = this.pricecodeData.find(
        el => el.Id == this.form.priceCode && !el.disabled,
      );
      if (!result) {
        this.form.priceCode = "";
      }
    },
    /**选择客户*/
    handleCustomer() {
      selectMember({
        method: getUserList,
        placeholder: "请输入客户姓名/编号",
        labelField: "Code",
        searchField: "Name",
        height: "80%",
        change: info => {
          this.currentCustomer = cloneDeep(info);
          this.form.customerId = info.Id;
          this.form.customerName = info.Name;
          this.setPriceCode();
          if (
            !this.defaultItem.IsIndependentPriceCode &&
            !this.form.member.CardNo &&
            info.PriceCodeId &&
            info.PriceCodeId != "0"
          ) {
            this.form.priceCode = info.PriceCodeId;
            this.handlePriceCode(info.PriceCodeId);
          } else if (
            !this.defaultItem.IsIndependentPriceCode &&
            info.SalesmanId &&
            info.SalesmanId != "0"
          ) {
            this.form.salesmanId = info.SalesmanId;
          }
        },
        clear: () => {
          this.form.customerId = "";
          this.form.customerName = "";
          this.setPriceCode();
          this.clearPriceCode();
          // this.pricecodeData = this.pricecodeData.map(item => {
          //   item.disabled = false;
          //   return item;
          // });
        },
      });
    },
    /**选择会员卡*/
    handleMember() {
      //显示会员卡选择器
      // if (this.isUpdate) {
      //   return;
      // }
      selectMember({
        height: "80%",
        change: info => {
          this.form.member = info;
          const payId = this.isMemberPayMethod();
          if (payId && this.roomInfoOption.actionType != "update") {
            this.form.payway = payId;
          }

          if (!this.form.contact) {
            this.form.contact = info.Name;
          }
          this.setPriceCode();
          if (
            !this.defaultItem.IsIndependentPriceCode &&
            info.PriceCodeId &&
            info.PriceCodeId !== "0"
          ) {
            this.form.priceCode = info.PriceCodeId;
            this.handlePriceCode(info.PriceCodeId);
          }
        },
        clear: () => {
          this.form.member = {
            CardNo: "",
            Name: "",
            Id: "",
          };
          this.setPriceCode();
          this.clearPriceCode();
          if (!this.defaultItem.IsIndependentPriceCode) {
            if (
              this.form.customerId &&
              this.currentCustomer.PriceCodeId &&
              this.currentCustomer.PriceCodeId != "0"
            ) {
              this.form.priceCode = this.currentCustomer.PriceCodeId;
              this.handlePriceCode(this.currentCustomer.PriceCodeId);
            }
          }
        },
      });
    },
    /**是否选择会员卡，并返回会员卡ID*/
    isMemberPayMethod() {
      const accountItem = this.paywayData.find(
        item => (item.Attributes & 4096) > 0,
      );
      if (accountItem) {
        return accountItem.Id;
      }
      return "";
    },
    setDailyPrice(record) {
      const start = record.daterange[0];
      const end = record.daterange[1];
      const dNum = moment(end, "YYYY-MM-DD").diff(
        moment(start).format("YYYY-MM-DD"),
        "d",
      );
      const days = dNum ? dNum : 1;
      record.TransactionPrices = [];
      for (let i = 0; i < days; i++) {
        record.TransactionPrices.push({
          Date: moment(start, "YYYY-MM-DD")
            .add(i, "d")
            .format("YYYY-MM-DD"),
          Price: record.BaseTransactionPrices[i]
            ? record.BaseTransactionPrices[i].Price
            : record.price,
          RoomTypeId: record.roomTypeId,
          RoomTypeName: record.roomTypeName,
        });
      }
      record.BaseTransactionPrices = record.TransactionPrices.map(v => {
        v.PriceDate = v.Date;
        return v;
      });
      // if (this.defaultItem.RoomPriceInputModel == "1") {
      //   //总房价
      //   this.$refs.roomInfo.handleTotalRoomPrice(record);
      // }
      // this.calculateTotalPrice();
    },
    /**计算每日价格*/
    changeDailyPrice(record, index) {
      const _this = this;
      let start = "",
        end = "";
      if (record.daterange) {
        start = record.daterange[0];
        end = record.daterange[1];
      } else {
        return false;
      }

      if (this.form.priceCode == "") {
        return false;
      }
      const isBeforeToday = moment(start, "YYYY-MM-DD").isBefore(
        this.user.AccountDate,
      );
      let checkInDate = moment(start).format("YYYY-MM-DD");
      const isAdditionalOder =
        moment(end).isBefore(this.user.AccountDate) &&
        (record.OrderStatus == 0 || record.OrderStatus == 1);
      if (
        this.IsHourRoom &&
        this.user.AccountDate != moment().format("YYYY-MM-DD") &&
        !isBeforeToday &&
        !isAdditionalOder &&
        this.roomInfoOption.actionType == "checkin"
      ) {
        checkInDate = this.user.AccountDate;
      }
      const params = {
        CheckInDate: checkInDate,
        CheckOutDate: moment(end).format("YYYY-MM-DD"),
        RoomTypeId: record.roomTypeId,
        PriceCodeId: this.form.priceCode,
      };
      if (record.roomTypeId > 0) {
        roomApi.GetRoomPrice(params).then(res => {
          let result = _this.priceStructureData.find(
            price => price.Id == record.priceStructure,
          );
          const addPrice = result && result.Data ? result.Data.Price : 0;
          let opt = cloneDeep(_this.roomInfoOption.gridData);
          let data = cloneDeep(res.Data);
          if (data.length) {
            opt[index].TransactionPrices = data.map((v, index) => {
              if (Number(addPrice) > 0) {
                v.Price = (Number(v.Price) + Number(addPrice)).toFixed(2);
              }
              v.PriceDate = v.Date;
              v.RoomNo = record.roomNo;
              if (this.roomInfoOption.actionType == "update") {
                v.Price =
                  record.DailyPrices && record.DailyPrices[index]
                    ? record.DailyPrices[index].Price
                    : v.Price;
              }
              return v;
            });
          }
          const price = data.length ? data[0].Price : 0;
          if (
            this.defaultItem.HoldPriceWhileEditingOrder == "1" &&
            this.defaultItem.RoomPriceInputModel == "1"
          ) {
            //总房价
            record.price = Number(record.price) > 0 ? record.price : price;
            opt[index].price =
              Number(opt[index].price) > 0 ? opt[index].price : price;
            // if (this.defaultItem.RoomPriceInputModel == "1") {
            this.$refs.roomInfo.handleTotalRoomPrice(opt[index]);
            // }
            // else {
            //   this.setDailyPrice(opt[index]);
            // }
          } else {
            record.price = price;
            opt[index].price = price;
            opt[index].BaseTransactionPrices = res.Data.map(v => {
              v.PriceDate = v.Date;
              return v;
            });
            if (this.defaultItem.RoomPriceInputModel == "1") {
              this.$refs.roomInfo.handleTotalRoomPrice(opt[index]);
            }
          }
          _this.roomInfoOption = {
            ..._this.roomInfoOption,
            gridData: opt,
          };
          _this.calculateTotalPrice();
        });
      }
    },
    calculateRoomPrice(isAllCancel) {
      this.isAllCancel = isAllCancel;
      this.calculateTotalPrice();
    },
    //计算总价
    calculateTotalPrice() {
      let total = 0;
      if (this.roomInfoOption.gridData && this.roomInfoOption.gridData.length) {
        this.roomInfoOption.gridData.forEach(item => {
          if (
            item.OrderStatus != 4 &&
            item.OrderStatus != 2 &&
            item.TransactionPrices &&
            item.TransactionPrices.length
          ) {
            item.TransactionPrices.forEach(el => {
              total += Number(el.Price);
            });
          }
        });
        this.totalMoney = total.toFixed(2);
      } else {
        this.totalMoney = "0.00";
      }
    },
    updateName(name) {
      if (!this.form.contact) {
        this.form.contact = name;
      }
    },
    setPriceCode() {
      const today = moment().format("YYYY-MM-DD");
      let endDay = today;
      this.pricecodeData = this.pricecodeData.map(item => {
        let isBetween = true;
        if (item.Data && (!item.Data.OffStartTime || !item.Data.OffEndTime)) {
          //如果可用时间段没选或者只选开始或结束 则不判断可用时间段
          isBetween = true;
        } else {
          const start = item.Data.OffStartTime;
          const end = item.Data.OffEndTime;
          //跨天
          if (moment(today + " " + end).isSameOrBefore(today + " " + start)) {
            endDay = moment()
              .add(1, "d")
              .format("YYYY-MM-DD");
          }
          isBetween = moment(moment().format("YYYY-MM-DD HH:mm")).isBetween(
            today + " " + start,
            endDay + " " + end,
          );
        }
        //会员专用或者客户专用或者在不在可用时间段内，价类初始不可选
        if (
          (item.Data.IsCustomerUse &&
            (!this.form.customerId || this.form.customerId == "0")) ||
          (item.Data.IsMemberUse &&
            (!this.form.member.Id || this.form.member.Id == 0)) ||
          !isBetween
        ) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        return item;
      });
    },
    /**获取搜索数据，包括房型数据和房间状态数据 */
    getFormSelectData() {
      const _this = this;
      //获取渠道列表
      getSelectData({
        Types: "channel",
      }).then(res => {
        _this.ChannelData = res.Data.channel;
      });
      //获取客户列表
      getSelectData({
        Types: "customer",
      }).then(res => {
        _this.customerData = res.Data.customer;
      });
      //获取业务员列表
      getSelectData({
        Types: "Salesman",
      }).then(res => {
        _this.salesmanData = res.Data.Salesman;
      });
      //获取价类
      getSelectData({
        Types: "pricecode",
      }).then(res => {
        _this.pricecodeData = res.Data.pricecode;
        _this.setPriceCode();
      });
      //获取价构列表
      getSelectData({
        Types: "PriceStructure",
      }).then(res => {
        _this.priceStructureData = res.Data.PriceStructure;
      });
      //获取付款方式
      roomApi
        .GetDepositList({
          Types: "payway",
        })
        .then(res => {
          this.paywayData = res.Data.map(item => {
            if (item.Attributes === 2) {
              item.disabled = true;
            }
            return item;
          });
        });
    },
  },
};
</script>
<style lang="less">
.van-cell {
  .van-field__label {
    width: 1.9rem;
    color: #666;
  }
}
.custom-filed {
  padding: 0;
}
.room-form {
  // padding-bottom: 1.16667rem;
  .total {
    color: #f00;
    font-size: 18px;
    line-height: 1.06667rem;
    padding: 0 10px;
  }
  /deep/.van-field__control:disabled {
    color: #323233;
    -webkit-text-fill-color: #323233;
    &::-webkit-input-placeholder {
      -webkit-text-fill-color: #999 !important;
    }
  }
}
.to-detail {
  text-align: left;
  border-top: 1px solid #f6f6f6;
  border-bottom: 1px solid #f6f6f6;
  margin-top: 20px;
  /deep/.van-cell__value {
    color: #000;
    font-size: 16px;
  }
}
.readonly-cls {
  background: #f9f9f9 !important;
  /deep/.van-field__right-icon {
    display: none;
  }
  .van-cell {
    background: #f9f9f9 !important;
  }
}
.van-cell .phone .van-field__label {
  width: 1rem;
}
.name-pop {
  top: 185px;
  left: 50%;
  width: 64%;
  border-radius: 3px;
  background: #ecf4ff;
  padding: #e9f6ff;
  li {
    border-bottom: 1px dashed #d5d5d5;
    padding: 8px 10px;
    font-size: 12px;
    color: 666;
    &:focus,
    &:active {
      background: #c4e7ff;
    }
  }
}
</style>
